import React from 'react';

const Switch = (props) => {
	
	var onCss=""
	var offCss=""
	if(props.off_valor==props.stat){
		offCss="encendido"
	}else if(props.on_valor==props.stat){
		onCss="encendido"
	}

	return <div className="switchCss">
      <div className={offCss+" text-center"} onClick={e => props.switchAct(props.dato, props.off_valor)}>
        {props.off}
      </div>
		<div className={onCss + "   text-center"} onClick={e => props.switchAct(props.dato, props.on_valor)}>
        {props.on}
      </div>
    </div>;
}
export default Switch;


// WEBPACK FOOTER //
// ./src/components/switch.js